import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeIn({ children, delay = 0, y = 28, className = "", ...rest }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden pb-1 ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1.1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function SectionHeader({ index, eyebrow, title, dark = false, className = "" }) {
    return (
        <div className={className}>
            <FadeIn>
                <div className="mb-6 flex items-center gap-3">
                    <span className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">{index}</span>
                    <span className={`h-px w-10 ${dark ? "bg-white/30" : "bg-ink/20"}`} />
                    <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-white/60" : "text-ink/50"}`}>
                        {eyebrow}
                    </span>
                </div>
            </FadeIn>
            <FadeIn delay={0.08}>
                <h2 className={`font-display text-4xl font-bold tracking-tighter sm:text-5xl ${dark ? "text-white" : "text-ink"}`}>
                    {title}
                </h2>
            </FadeIn>
        </div>
    );
}
